var AgeVerification = class extends HTMLElement {
  constructor() {
    super();
    let status = localStorage.getItem("age-verification-status") || null
    if (status !== "confirmed") {
      this.classList.remove("hidden")
    }
    this.confirm = this.querySelector("#custom-confirm")
    this.cancel = this.querySelector("#custom-cancel")
    this.confirm.addEventListener("click",this.confirmClick.bind(this))
    this.cancel.addEventListener("click",this.cancelClick.bind(this))
    this.errorBox = this.querySelector(".age-restrictions-pop-error")
  }
  confirmClick(){
    localStorage.setItem("age-verification-status", "confirmed");
    this.remove();
  }
  cancelClick(){
    localStorage.setItem("age-verification-status", "cancelled");
    this.errorBox.style.display = "block"
  }
};
if (!window.customElements.get("age-verification")) {
  window.customElements.define("age-verification", AgeVerification);
}


  const bttButtom = document.querySelector(".custom-to-top");
  if (bttButtom){
        let showAt = window.innerHeight * 1.5
    window.addEventListener("scroll", function(){
        bttButtom.classList.toggle("custom-to-top-hidden", window.scrollY <= showAt);
    }, { passive: true });
    bttButtom.addEventListener("click", function(){
        window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }


var CustomReadMore = class extends HTMLElement {
  constructor() {
    super();
  
  }
  connectedCallback() {
    this.content = this.querySelector(".custom-read-more-content");
    this.button = this.querySelector(".custom-read-more-button");
    if (!this.content || !this.button) return;
    requestAnimationFrame(() => {
      this.init();
    });
  }
  
  init() {
    this.isMobile = window.innerWidth <= 768;
    this.limitHeight = this.isMobile ? 40 : 50;
    this.fullHeight = this.content.scrollHeight;
    if (this.fullHeight <= this.limitHeight) return;
    this.collapse();
    this.button.style.display = "block";
    this.button.textContent = "Read More >>";

    this.button.onclick = () => this.toggle();
  }
  toggle() {
    this.expanded ? this.collapse() : this.expand();
  }
   expand() {
    this.expanded = true;
    this.content.style.maxHeight = this.fullHeight + "px";
    this.content.style.overflow = "visible";
    this.button.textContent = "Read Less <<";
    this.content.classList.add("open")
  }

  collapse() {
    this.expanded = false;
    this.content.style.maxHeight = this.limitHeight + "px";
    this.content.style.overflow = "hidden";
    this.button.textContent = "Read More >>";
    this.content.classList.remove("open")
  }
};
if (!window.customElements.get("custom-read-more")) {
  window.customElements.define("custom-read-more", CustomReadMore);
}
  